module.exports = __webpack_public_path__ + "img/Group_4.4da959fb.png";